import { useEffect } from 'react';

export function usePreventScroll(isOpen: boolean) {
  useEffect(() => {
    if (isOpen) {
      document.body.classList.add('dialog-scroll-lock');
    } else {
      document.body.classList.remove('dialog-scroll-lock');
    }
    return () => {
      document.body.classList.remove('dialog-scroll-lock');
    };
  }, [isOpen]);
}